import React, { useEffect } from 'react'
import { Modal, Form, Input, Select } from 'antd'
import type { User } from '../types/user.types'

interface UserFormModalProps {
    open: boolean
    onCancel: () => void
    onSubmit: (values: any) => void
    initialValues?: User | null
}

export const UserFormModal: React.FC<UserFormModalProps> = ({
    open,
    onCancel,
    onSubmit,
    initialValues
}) => {
    const [form] = Form.useForm()

    useEffect(() => {
        if (open) {
            if (initialValues) {
                form.setFieldsValue(initialValues)
            } else {
                form.resetFields()
                form.setFieldsValue({ status: 'active' })
            }
        }
    }, [open, initialValues, form])

    const handleOk = () => {
        form.validateFields().then(onSubmit)
    }

    return (
        <Modal
            title={initialValues ? "Edit User" : "Add New User"}
            open={open}
            onOk={handleOk}
            onCancel={onCancel}
            width={600}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    label="Full Name"
                    name="full_name"
                    rules={[{ required: true, message: 'Please enter full name' }]}
                >
                    <Input placeholder="Enter user name" />
                </Form.Item>
                <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                        { type: 'email', message: 'Please enter valid email' }
                    ]}
                >
                    <Input placeholder="Enter user email" />
                </Form.Item>
                <Form.Item
                    label="Phone"
                    name="mobile"
                    rules={[{ required: true, message: 'Please enter phone number' }]}
                >
                    <Input placeholder="Enter phone number" />
                </Form.Item>
                {!initialValues && (
                    <Form.Item
                        label="User ID"
                        name="user_id"
                        rules={[{ required: true, message: 'Please enter user ID' }]}
                    >
                        <Input type="number" placeholder="Enter user ID from auth service" />
                    </Form.Item>
                )}

                <Form.Item
                    label="Status"
                    name="status"
                    rules={[{ required: true }]}
                >
                    <Select>
                        <Select.Option value="active">Active</Select.Option>
                        <Select.Option value="suspended">Suspended</Select.Option>
                        <Select.Option value="blocked">Blocked</Select.Option>
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    )
}
